import { RichTextContent } from '@travelwin/cms/types';
import { Config, getCurrencyOrDefault } from '@travelwin/core';
import cookie from 'cookie';
import { unique } from 'radash';
import { Params } from 'react-router';

import i18n from '../../app/i18n';
import { CURRENCY_STORAGE_KEY } from '../constants';
import {
  isLexicalBlockNode,
  traverseLexicalNodes,
} from '../utils/lexicalUtilts';

export const isRemix = () => {
  return typeof window === 'undefined' || '__reactRouterManifest' in window;
};

export const isClient = () => {
  return typeof window !== 'undefined';
};

export const getUniteBaseUrl = () => {
  if (typeof window === 'undefined') {
    return process.env.REACT_APP_API_ENDPOINT_ECOMMERCE;
  } else {
    return window.ENV.REACT_APP_API_ENDPOINT_ECOMMERCE;
  }
};

export const getCmsBaseUrl = () => {
  if (typeof window === 'undefined') {
    return process.env.REACT_APP_CMS_ENDPOINT;
  } else {
    return window.ENV.REACT_APP_CMS_ENDPOINT;
  }
};

// used in deployed environments to point to CloudFront directly
// instead routing images through the CMS
export const getCmsMediaBaseUrl = () => {
  if (typeof window === 'undefined') {
    return process.env.REACT_APP_CMS_MEDIA_ENDPOINT;
  } else {
    return window.ENV.REACT_APP_CMS_MEDIA_ENDPOINT;
  }
};

export const getCurrency = ({
  request,
  config,
}: {
  request: Request;
  config: Config;
}) => {
  const url = new URL(request.url);
  const queryParamCurrency =
    url.searchParams.get(CURRENCY_STORAGE_KEY)?.toUpperCase() || undefined;

  const cookieHeader = request.headers.get('Cookie');
  const cookieCurrency = cookieHeader
    ? cookie.parse(cookieHeader)[CURRENCY_STORAGE_KEY]
    : undefined;

  const currencyValue = getCurrencyOrDefault(
    queryParamCurrency,
    cookieCurrency,
    config,
  );

  return currencyValue;
};

export const assertValidLang = (params: Params) => {
  const isInvalidLang =
    params.lang &&
    (params.lang === 'en' || !i18n.supportedLngs.includes(params.lang));

  if (isInvalidLang) {
    throw new Response(null, { status: 404, statusText: 'Not Found' });
  }
};

export const extractPlanIds = (content: RichTextContent) => {
  const planIds: string[] = [];

  traverseLexicalNodes(content.root, (node) => {
    if (isLexicalBlockNode(node) && node.fields.blockType === 'plan-card') {
      planIds.push(node.fields.planId);
    } else if (
      isLexicalBlockNode(node) &&
      node.fields.blockType === 'plan-price'
    ) {
      planIds.push(node.fields.planId);
    }
  });

  return unique(planIds);
};

export const getServerUserAgent = (request: Request) => {
  return request.headers.get('user-agent') || 'Unknown';
};
